export interface ILink {
  href: string;
  target?: '_self' | '_blank' | '_parent' | '_top';
}

export interface ILinks {
  help: ILink;
  gamelab: ILink;
  app: ILink;
}

export const links: ILinks = {
  help: {
    href: ''
  },
  gamelab: {
    href: 'https://gl.sberlabs.com/',
    target: '_blank'
  },
  app: {
    href: 'https://app.io'
  }
};
